module.exports = __webpack_public_path__ + "img/3.d8c53f50.webp";